import { tailwindConfig } from "./tailwind-config";

tailwind.config = tailwindConfig;
